var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "search-form",
      attrs: { id: "search-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return ((event) => _vm.submitHandler(event, _vm.submit)).apply(
            null,
            arguments
          )
        },
      },
    },
    [
      _vm.mode === "default"
        ? _c("h3", [_vm._v("Search for a code")])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "search-form__input placeholder",
        attrs: {
          name: "term",
          type: "text",
          placeholder: "Enter keyword(s) or code",
        },
        domProps: { value: _vm.term },
      }),
      _c("button", {
        staticClass: "search-form__button",
        attrs: {
          type: "submit",
          value: "Search",
          form: "search-form",
          "data-gtm-category": "Search",
          "data-gtm-action": "Search button",
          "data-gtm-label": "Search",
        },
      }),
      _vm._v(" "),
      !_vm.helpForSearchTerm && !_vm.nbResults
        ? _c("div", { staticClass: "search-form__help help" }, [
            _c("p", [
              _vm._v(
                "Describe the goods or services the business produces or sells, for example ‘clothing retailing’ not ‘retailing’."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "If you are self-employed, describe what you do, for example ‘dairy farming’ not ‘dairy farmer’."
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.helpForSearchTerm
        ? _c("div", {
            staticClass: "search-form__help",
            domProps: { innerHTML: _vm._s(_vm.helpForSearchTermEdited) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v("Need help? See the BIC code "),
      _c("a", { attrs: { href: "/help/" } }, [_vm._v("help page.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }